import Vue from 'vue';
import Router from 'vue-router';
import HomePage from '@/components/homePage';
import QRScanner from '@/components/QRScanner';
import EventScanner from '@/components/EventScanner';

Vue.use(Router);

export default new Router({
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage,
    },
    {
      path: '/:code',
      name: 'QRScanner',
      component: QRScanner,
    },
    {
      path: '/event/:code',
      name: 'EventScanner',
      component: EventScanner,
    },
    { path: '*', redirect: '/' },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js